// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"9af2d341","437":"c6b1a841","786":"39bd774d"}[chunkId] + ".chunk.js";
};